var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { User } from '@/models/User';
import StudentRoster from '@/views/Users/Student/Roster';
import TeacherRoster from '@/views/Users/Teacher/Roster';
import { RolesEnum } from '@/items/Roles';
let UserRoster = class UserRoster extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'UserRoster';
    }
    mounted() {
        const hideRosterSetting = this.$store.getters.getSetting('hide_my_roster');
        // Redirect when user does not have permission
        if (hideRosterSetting && hideRosterSetting.value && (!this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.BOARD]))) {
            this.$router.push('/');
        }
    }
    get user() {
        return (this.$store.state.Auth ||
            new User({
                name: 'Undefined',
            }));
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.TEACHER]);
    }
};
UserRoster = __decorate([
    Component({
        components: {
            StudentRoster,
            TeacherRoster,
        },
    })
], UserRoster);
export default UserRoster;
